<div class="facet-panel">
  @for (section of sections; track section.name) {
    <section class="facet-section" [attr.data-testid]="'facet-' + section.name">
      <header class="facet-header">
        <button
          type="button"
          class="facet-toggle"
          [attr.aria-expanded]="!isCollapsed(section)"
          [attr.aria-label]="(isCollapsed(section) ? 'Show ' : 'Hide ') + section.title"
          (click)="toggleCollapsed(section)"
        >
          <svg-icon class="facet-chevron" [key]="isCollapsed(section) ? 'chevron-down' : 'chevron-up'" [fontSize]="12" />
          <span class="facet-title">{{ section.title }}</span>
          @if (section.universe != null) {
            <span class="facet-universe">{{ section.totalValues }} of {{ section.universe }}</span>
          }
          @if (isCollapsed(section) && hasSelection(section)) {
            <span class="facet-selected-count">{{ selectedCount(section) }} selected</span>
          }
        </button>
        @if (section.hint) {
          <svg-icon class="facet-hint-icon" key="information-circle" [fontSize]="14" [tooltip]="section.hint" [maxWidth]="'320px'" />
        }
        @if (hasSelection(section)) {
          <button type="button" class="btn btn-link facet-clear" [disabled]="disabled" (click)="clear(section)">Clear</button>
        }
      </header>

      @if (!isCollapsed(section)) {
        @if (section.searchable && section.values.length > 0) {
          <shared-search-input
            class="facet-search"
            [searchValue]="getSearchText(section)"
            [placeholder]="section.searchPlaceholder ?? 'Search…'"
            [debounceTime]="0"
            [disabled]="disabled"
            (searchValueChange)="setSearchText(section, $event)"
            (clear)="setSearchText(section, '')"
          />
        }
        @if (section.values.length === 0) {
          <p class="facet-empty">{{ section.emptyText ?? 'Nothing in the selection.' }}</p>
        } @else {
          <ul class="facet-values">
            @for (value of visibleValues(section); track value.id) {
              <li>
                <button
                  type="button"
                  class="facet-value"
                  [class.selected]="isSelected(section, value)"
                  [disabled]="disabled"
                  [attr.title]="(section.countLabel ? value.count + ' ' + section.countLabel : value.count) + (value.secondaryCount != null && section.secondaryCountLabel ? ' · ' + value.secondaryCount + ' ' + section.secondaryCountLabel : '')"
                  (click)="onValueClick(section, value, $event)"
                >
                  <span class="facet-label" [tooltip]="value.suffix ? value.label + ' (' + value.suffix + ')' : value.label" tooltipIfEllipsis>
                    {{ value.label }}
                    @if (value.suffix) {
                      <small class="facet-suffix">({{ value.suffix }})</small>
                    }
                  </span>
                  <span class="facet-counts">
                    @if (value.secondaryCount != null) {
                      <small class="facet-secondary">{{ value.secondaryCount }}</small>
                    }
                    <span class="facet-count">{{ value.count }}</span>
                  </span>
                </button>
              </li>
            }
          </ul>
          @if (visibleValues(section).length === 0) {
            <p class="facet-empty">No match.</p>
          } @else if (hiddenCount(section) > 0) {
            <p class="facet-more">{{ hiddenCount(section) }} more — narrow with the search box</p>
          }
          @if (section.emptyText && section.values.length > 0 && section.totalValues === 0) {
            <p class="facet-empty">{{ section.emptyText }}</p>
          }
        }
      }
    </section>
  }
</div>
